import {Box, Typography} from '@mui/material';
import {FC, useMemo, useState} from 'react';
import {smallBlocksStyle} from './SmallBlocks.styles';
import {BODY1, H2} from '@/utils/constants';
import ActionsMenu from '@/shared/components/Table/ActionMenu';
import {teamSectionStyle} from '@/pages/Organization/Profile/Team/Team.styles';
import Modal from '@/shared/components/Modal';
import AuctionParticipantsModal from '../AuctionPartiсipantsModal';
import {ReportsModalTablesStyle} from '../UnpaidItemsModal/ReportsModalTables.style';
import UnpaidItemsModal from '../UnpaidItemsModal';
import UnpaidTablesModal from '../UnpaidTablesModal';
import ValueofMaxBidsModal from '../ValueofMaxBidsModal';
import {IOrganizationFullReport} from '@/utils/types/organization-reports.interface';

interface ISmallBlocks {
	statistic: IOrganizationFullReport;
}

const SmallBlocks: FC<ISmallBlocks> = ({statistic}) => {
	const [isUnpaidItemsModalOpened, setIsUnpaidItemsModalOpened] = useState(false);
	const [isUnpaidTablesModalOpened, setIsUnpaidTablesModalOpened] = useState(false);
	const [isAuctionParticipantsModalOpened, setIsAuctionParticipantsModalOpened] = useState(false);
	const [isValueofMaxBidsModalOpened, setIsValueofMaxBidsModalOpened] = useState(false);

	const smallItemsData = useMemo(
		() => [
			{
				name: 'Unpaid Items',

				data: statistic!.unpaidItems!.totalCount ?? 0,
				actions: [{name: 'Go to Details', action: () => setIsUnpaidItemsModalOpened(true)}],
			},
			{
				name: 'Unpaid Tables',
				data: statistic!.unpaidTables!.totalCount ?? 0,
				actions: [{name: 'Go to Details', action: () => setIsUnpaidTablesModalOpened(true)}],
			},
			{
				name: 'Auction Participants',
				data: statistic!.participants!.totalCount ?? 0,
				actions: [{name: 'Go to Details', action: () => setIsAuctionParticipantsModalOpened(true)}],
			},
			{
				name: 'Value of Max Bids',
				data: statistic!.maxBids!.totalCount ?? 0,
				actions: [
					{
						name: 'Go to Details',
						action: () => {
							setIsValueofMaxBidsModalOpened(true);
						},
					},
				],
			},
		],
		[statistic]
	);

	return (
		<>
			<Box sx={smallBlocksStyle.wrapper}>
				{smallItemsData.map((item, index) => (
					<Box key={index} sx={smallBlocksStyle.item}>
						<Box sx={smallBlocksStyle.topBlock}>
							<Typography sx={smallBlocksStyle.data}>{item.data}</Typography>
							<ActionsMenu
								content={item.actions.map((el, index) => (
									<Box key={index} sx={teamSectionStyle.menuContent} onClick={el.action}>
										<Typography variant={BODY1}>{el.name}</Typography>
									</Box>
								))}
							/>
						</Box>
						<Typography variant={H2} sx={smallBlocksStyle.name}>
							{item.name}
						</Typography>
					</Box>
				))}
			</Box>

			<Modal
				onClose={() => setIsUnpaidItemsModalOpened(false)}
				open={isUnpaidItemsModalOpened}
				title="Unpaid Items"
				parentClassName={{width: '100%'}}
				sx={ReportsModalTablesStyle.modalWrapper}
			>
				<UnpaidItemsModal />
			</Modal>
			<Modal
				onClose={() => setIsUnpaidTablesModalOpened(false)}
				open={isUnpaidTablesModalOpened}
				title="Unpaid Tables"
				parentClassName={{width: '100%'}}
				sx={ReportsModalTablesStyle.modalWrapper}
			>
				<UnpaidTablesModal />
			</Modal>
			<Modal
				onClose={() => setIsAuctionParticipantsModalOpened(false)}
				open={isAuctionParticipantsModalOpened}
				title=" Auction partiсipants"
				parentClassName={{width: '100%'}}
				sx={ReportsModalTablesStyle.modalWrapper}
			>
				<AuctionParticipantsModal />
			</Modal>
			<Modal
				onClose={() => setIsValueofMaxBidsModalOpened(false)}
				open={isValueofMaxBidsModalOpened}
				title="Value of Max Bid"
				parentClassName={{width: '100%'}}
				sx={ReportsModalTablesStyle.modalWrapper}
			>
				<ValueofMaxBidsModal />
			</Modal>
		</>
	);
};

export default SmallBlocks;
